export interface FrameworkTemplateCategorySaveModel {
    id: string;
    customId?: string;
    languages: Array<FrameworkTemplateCategoryLanguageSaveModel>;
}

export interface FrameworkTemplateCategoryLanguageSaveModel {
    name: string;
    description: string | undefined;
    twoLetterIsoLanguage: string;
}

export function createNewModel(): FrameworkTemplateCategorySaveModel {
    return {
        id: "",
        customId: "",
        languages: [
            {
                name: "",
                description: "",
                twoLetterIsoLanguage: "da",
            },
            {
                name: "",
                description: "",
                twoLetterIsoLanguage: "en",
            },
        ],
    };
}
